"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcDepthForNode = void 0;
function calcDepthForNode(node) {
    var _a, _b, _c;
    if ((_b = (_a = node === null || node === void 0 ? void 0 : node.parentNode) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 ? void 0 : _b.parentNode)
        return 2;
    if ((_c = node === null || node === void 0 ? void 0 : node.parentNode) === null || _c === void 0 ? void 0 : _c.parentNode)
        return 1;
    return 0;
}
exports.calcDepthForNode = calcDepthForNode;
exports.default = calcDepthForNode;
